import { Component, OnInit, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import pdfMake from 'pdfmake/build/pdfmake';
import htmlToPdfmake from 'html-to-pdfmake';
import { AdvAdvertisementService } from 'src/app/services/adv-advertisement.service';

const marathiFont = {
  MarathiFont: {
    normal: '../../../assets/fonts/TiroDevanagariMarathi-Regular.ttf',
    bold: '../../../assets/fonts/TiroDevanagariMarathi-Italic.ttf'
  },

};

pdfMake.fonts = {
  ...pdfMake.fonts,
  'MarathiFont': marathiFont.MarathiFont,
  'Roboto': {
    normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
    bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
    italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
    bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
  }
};

@Component({
  selector: 'app-adv-advertisement-list',
  templateUrl: './adv-advertisement-list.component.html',
  styleUrls: ['./adv-advertisement-list.component.scss']
})
export class AdvAdvertisementListComponent implements OnInit {

  allAdvertisement: any = []
  pdfTable: any = '';
  constructor(private dialog: MatDialog, private advAdvertisementService: AdvAdvertisementService) {
  }

  downloadAsPDF() {
    const pdfTable = sessionStorage.getItem('htmlContent');
    var html = htmlToPdfmake(pdfTable!);
    console.log("pdfTable", pdfTable)
    const documentDefinition = { content: html };
    pdfMake.createPdf(documentDefinition, {}, marathiFont, marathiFont.MarathiFont).open();
  }

  ngOnInit(): void {
    this.getAllAdvertisement()
  }

  getAllAdvertisement() {
    this.advAdvertisementService.getAdvertisements().subscribe(
      (data: any) => {
        this.allAdvertisement = data;
      });
  }

  downloadPDF(url: any) {
    const a = document.createElement('a')
    a.href = url
    a.download = url?.split('/').pop()
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }

  advertisementId: any
  openDialog(id: string, dialog: TemplateRef<any>) {
    this.advertisementId = id
    this.dialog.open(dialog, {
      width: '30vw',
      height: '20vh'
    })
  }

  deleteAdvertise(id: any) {
    this.advAdvertisementService.deleteAdvertisement(id).subscribe((data: any) => {
      console.log(data)
      if (data) {
        this.advAdvertisementService.successToast('Successfully deleted');
        this.getAllAdvertisement();
      }
    });
  }
}
